import * as z from "zod";

export const CustomerAccountsAdBlocksFlatTeamSettingsSchema = z.object({
  "customerAccounts/adBlocks": z.array(z.unknown()).nullish(),
});
